import PropTypes from "prop-types";
import React, { useEffect } from "react";
import MyAccountTemplate from "../../sections/my-account-template";
import "./style.scss";

import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import AccountPreferredSetting from "../../sections/account-preferred-setting";
import AccountAreaOfInterestSetting from "../../sections/account-areaOfInterest-setting";
import AccountNewsletterSetting from "../../sections/account-newsletter-setting";
import { genrateHeadingWithFirstName } from "../../utils/myAccount";
import { getUserInfo } from "../../services/userService";
import { setUserInfoAction } from "../../redux/actions";

function MyAccountSetting({ fields, user, lang, page, setUserInfo }) {
  const { accountMenu, hero, interestSetting, newsletterSetting, preferredSetting } = fields;
  useEffect(() => {
    init().then();
  }, []);
  const init = async () => {
    const user = await getUserInfo();
    setUserInfo(user);
  };
  return (
    <div className="my-account-settings">
      <MyAccountTemplate
        heroConfiguration={{
          ...hero[0].fields,
          titleBody: genrateHeadingWithFirstName(hero[0].fields.titleBody, user ? user.firstName : "")
        }}
        menu={accountMenu[0].fields}
      >
        <div className="my-account-settings-content">
          <AccountPreferredSetting {...{ ...preferredSetting, lang }} />
          <AccountAreaOfInterestSetting {...{ ...interestSetting, lang }} />
          <AccountNewsletterSetting {...{ ...newsletterSetting, lang }} />
        </div>
      </MyAccountTemplate>
    </div>
  );
}

const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(MyAccountSetting);
MyAccountSetting.propTypes = {
  heroConfiguration: PropTypes.shape({
    heading: PropTypes.shape({
      type: PropTypes.string,
      html: PropTypes.string,
      typographyClass: PropTypes.string
    }),
    overline: PropTypes.string,
    body: PropTypes.string
  }),
  menu: PropTypes.shape({
    menuItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
        route: PropTypes.string,
        routeType: PropTypes.oneOf(["internal", "external"]),
        isActive: PropTypes.bool
      })
    ),
    heading: PropTypes.shape({
      type: PropTypes.string,
      text: PropTypes.string,
      typographyClass: PropTypes.string
    }),
    button: PropTypes.shape({
      buttonText: PropTypes.string,
      icon: PropTypes.shape({ svg: PropTypes.string }),
      colorScheme: PropTypes.string,
      externalLink: PropTypes.string
    }),
    logoutLink: PropTypes.shape({
      buttonText: PropTypes.string,
      externalLink: PropTypes.string
    }),
    body: PropTypes.string
  }),
  changeEmail: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.string,
    emailAddress: PropTypes.object,
    button: PropTypes.object
  }),
  changePassword: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.string,
    oldPassword: PropTypes.object,
    newPassword: PropTypes.object,
    button: PropTypes.object
  }),
  pereferedLanguageAndCountry: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.string,
    emailAddress: PropTypes.object,
    button: PropTypes.object,
    languangeOptions: PropTypes.object
  }),
  areaOfInterest: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.string,
    checkboxes: PropTypes.arrayOf(PropTypes.object),
    button: PropTypes.object
  }),
  newsletterPreferences: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.string,
    checkbox: PropTypes.object,
    button: PropTypes.object
  })
};
